import { render, staticRenderFns } from "./relatorio-procedimentos-quantitativo.vue?vue&type=template&id=4660c32a&scoped=true"
import script from "./relatorio-procedimentos-quantitativo.vue?vue&type=script&lang=js"
export * from "./relatorio-procedimentos-quantitativo.vue?vue&type=script&lang=js"
import style0 from "./relatorio-procedimentos-quantitativo.vue?vue&type=style&index=0&id=4660c32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4660c32a",
  null
  
)

export default component.exports